<script>
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';

export default Vue.extend({
    data() {
        return {
            collapseObject: undefined
        }
    },
    computed: {
        ...mapState({
            sites: state => state.contract.contract.item.sites.sites
        }),
        ...mapGetters({
            getContractCollapseObject: 'contract/getContractCollapseObject'
        })
    },
    created() {
        this.collapseObject = this.getContractCollapseObject;
    },
    methods: {
        collapse(obj) {
            for(let i = 0; i < this.collapseObject.length; i++) {
                this.collapseObject[i].collapse = !(i === obj.siteIndex);
                // Use the timeout to ensure that the element is collapsed
                setTimeout(() => {document.getElementById('site_' + obj.siteIndex).scrollIntoView();}, 10)
            }
            this.$forceUpdate();
        }
    },
});
</script>
<template>
    <div class="contract-form-site">
        <div class="contract-form-site__content">
            <div class="contract-form-site__header">
                <div class="contract-form-site__heading">
                    {{ $t('contract.form.sites.header.heading') }}
                </div>
            </div>
            <div class="contract-form-site__body">
                <div class="contract-form-site__sites">
                    <div v-for="(site, siteIndex) in sites" :id="'site_' + siteIndex" :key="'site_' + siteIndex" class="contract-form-site__site">
                        <div :class="{'contract-form-site__site-header--collapsed': collapseObject[siteIndex].collapse}" class="contract-form-site__site-header" @click="collapse({siteIndex: siteIndex})">
                            {{ site.name }}
                        </div>
                        <div v-if="!collapseObject[siteIndex].collapse" class="contract-form-site__content">
                            <div class="contract-form-site__site-address">
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.extra.address}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.address') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data">{{ site.extra.address }}</div>
                                </div>
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.extra.zipCode}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.zipCode') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data">{{ site.extra.zipCode }}</div>
                                </div>
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.extra.city}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.city') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data">{{ site.extra.city }}</div>
                                </div>
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.extra.country}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.country') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data">{{ site.extra.country }}</div>
                                </div>
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.extra.website}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.website') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data"><a :href="'http://' + site.extra.website" target="_blank">{{ site.extra.website }}</a></div>
                                </div>
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.extra.email}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.email') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data"><a :href="'mailTo:' + site.extra.email">{{ site.extra.email }}</a></div>
                                </div>
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.extra.phone}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.phone') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data"><a :href="'tel:' + site.extra.phone">{{ site.extra.phone }}</a></div>
                                </div>
                                <div class="contract-form-site__site-address-element">
                                    <div :class="{'contract-form-site__site-address-element-label--inactive': !site.rating}" class="contract-form-site__site-address-element-label">
                                        {{ $t('contract.form.sites.rating') }}
                                    </div>
                                    <div class="contract-form-site__site-address-element-data">{{ site.rating }}/5</div>
                                </div>
                            </div>
                            <div class="contract-form-site__site-images">
                                <a v-for="(image, imageIndex) in site.imagesS3" :href="image" :key="'image_' + imageIndex" target="_blank" class="contract-form-site__site-image-wrapper">
                                    <img :src="imageIndex" alt="" class="contract-form-site__site-image">
                                    <span class="contract-form-site__site-image-overlay">{{ $t('contract.form.sites.view') }}</span>
                                </a>
                            </div>
                            <div class="contract-form-site__site-facilities">
                                <div class="contract-form-site__site-facilities-header">
                                    {{ $t('contract.form.sites.facilities.header') }}
                                </div>
                                <div v-for="(facility, facilityIndex) in site.facilities" :key="'facility_' + facilityIndex" class="contract-form-site__site-facility-elements">
                                    <div class="contract-form-site__site-facility-element">
                                        <div class="contract-form-site__site-facility-element-label">{{ facility.name }}</div>
                                        <div class="contract-form-site__site-facility-element-items">
                                            <div v-for="(item, itemIndex) in facility.extraInfo" :key="'item_' + itemIndex" class="contract-form-site__site-facility-element-item">
                                                {{ item }}
                                            </div>
                                        </div>
                                        <div v-if="facility.number || facility.distance || facility.size || facility.startDate || facility.endDate" class="contract-form-site__site-facility-element-data-list">
                                            <div class="contract-form-site__site-facility-element-data-header">
                                                {{ $t('contract.form.sites.facilities.dataHeader') }}:
                                            </div>
                                            <div v-if="facility.number" class="contract-form-site__site-facility-element-data">
                                                <span class="contract-form-site__site-facility-element-data-value">
                                                    {{ $t('contract.form.sites.facilities.number') }}: {{ facility.number }}
                                                </span>
                                            </div>
                                            <div v-if="facility.distance" class="contract-form-site__site-facility-element-data">
                                                <span class="contract-form-site__site-facility-element-data-value">
                                                    {{ $t('contract.form.sites.facilities.distance') }}: {{ facility.distance }}
                                                </span>
                                            </div>
                                            <div v-if="facility.size" class="contract-form-site__site-facility-element-data">
                                                <span class="contract-form-site__site-facility-element-data-value">
                                                    {{ $t('contract.form.sites.facilities.size') }}: {{ facility.size }}
                                                </span>
                                            </div>
                                            <div v-if="facility.startDate" class="contract-form-site__site-facility-element-data">
                                                <span class="contract-form-site__site-facility-element-data-value">
                                                    {{ $t('contract.form.sites.facilities.startDate') }}: {{ facility.startDate }}
                                                </span>
                                            </div>
                                            <div v-if="facility.endDate" class="contract-form-site__site-facility-element-data">
                                                <span class="contract-form-site__site-facility-element-data-value">
                                                    {{ $t('contract.form.sites.facilities.endDate') }}: {{ facility.endDate }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="sites.length === 0" class="contract-form-site__no-content">
                <i class="fa fa-bullhorn"/>
                <div class="manage-allocation-list__no-content-message">{{ $t('contract.form.sites.noContent') }}</div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormSite/ContractFormSite.vue